var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock-(2)",
    fill: "#A8CEFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C4.48577883,20 0,15.5142212 0,10 C0,4.48577883 4.48577883,0 10,0 C15.5142212,0 20,4.48577883 20,10 C20,15.5142212 15.5142212,20 10,20 Z M10,1.25 C5.17501832,1.25 1.25,5.17501832 1.25,10 C1.25,14.8249817 5.17501832,18.75 10,18.75 C14.8249817,18.75 18.75,14.8249817 18.75,10 C18.75,5.17501832 14.8249817,1.25 10,1.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3652171,15.7142857 C14.2026073,15.7142857 14.0401525,15.6535618 13.9164512,15.5313531 L9.47188624,11.1677554 C9.35252538,11.050569 9.28571429,10.8918346 9.28571429,10.727317 L9.28571429,4.90908537 C9.28571429,4.56498333 9.57016522,4.28571429 9.92065214,4.28571429 C10.2711391,4.28571429 10.55559,4.56498333 10.55559,4.90908537 L10.55559,10.4687458 L14.813983,14.649563 C15.0620057,14.8930674 15.0620057,15.2878487 14.813983,15.5313531 C14.6902818,15.6535618 14.527827,15.7142857 14.3652171,15.7142857 L14.3652171,15.7142857 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d88643ca99d98c51a1d9142a2642bc2d.svg";
export { ForwardRef as ReactComponent };